const SEED_CHARS = '0123456789ABCDEF'

export function randomColor(): string {
  const color = Array
    .apply(null, new Array(6))
    .map(() => SEED_CHARS[Math.floor(Math.random() * 16)])
    .join('')

  return `#${color}`
}
